// extracted by mini-css-extract-plugin
export var root = "_46a101396ef7852e3f85de98e122724f-css";
export var inner = "_6531af5aa5bf7d080e05365851c08913-css";
export var note = "_0f7ec9d5d69b835dc7351f34cf0d9de0-css";
export var form = "d730439cd6737a6c68b959864e59662d-css";